import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import { HeadingS } from "./Typography";

export const CalculatorDialog = styled(Dialog)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiDialog-paper": {
            width: "960px",
            maxWidth: "95vw",
            maxHeight: "90vh",
            borderRadius: 2,
            overflow: "hidden",
        },
    }),
);

export const ModalHeader = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        px: 5,
        pt: 4,
        pb: 2,
    }),
);

export const ModalHeading = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);
